import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, timeout } from 'rxjs/operators';
import { ApiService } from '../services';
import { ProgressbarService } from '../../shared/components/progressbar/progressbar.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  blackList: string[] = [];

  constructor(
    private progressbarService: ProgressbarService,
    private apiService: ApiService
  ) {
    this.blackList.push(`${this.apiService.searchProduct}/search?text`);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const shouldHandle = !this.isInBlacklist(request);

    if (shouldHandle) {
      this.progressbarService.show();
    }

    return next.handle(request).pipe(
      timeout(180000),
      finalize(() => {
        if (shouldHandle) {
          this.progressbarService.hide();
        }
      })
    );
  }

  private isInBlacklist(request: HttpRequest<any>) {
    return this.blackList.some((url) => {
      return request.url.includes(url);
    });
  }
}